import { BaseEnum } from "../../BaseEnum";

export class HSType extends BaseEnum {
  static ONSITE_HEAT_AND_STEAM = 1;
  static DISTRICT_HEAT_AND_STEAM = 2;

  static Codes = [this.ONSITE_HEAT_AND_STEAM, this.DISTRICT_HEAT_AND_STEAM];
  static _labelKeys = [
    "enums.hs-type.ONSITE_HEAT_AND_STEAM",
    "enums.hs-type.DISTRICT_HEAT_AND_STEAM",
  ];
}
